export default __webpack_public_path__ + "static/media/usingInPageHelp.057f8145.png";